export function PageTitle({ children, ...props }) {
  return (
    <div>
      <h1 className="text-4xl font-bold leading-none text-white" {...props}>
        {children}
      </h1>
    </div>
  );
}
